import { useUserIdentifier } from "../hooks/useUserIdentifier";
import {
	getQueryKeyFactory,
} from "../queryHooks/query-key-factory";

export const useQueryKeyFactory = () => {
	const userIdentifier = useUserIdentifier();

	return { createQueryKey: getQueryKeyFactory(userIdentifier) }
};
